import Phaser from 'phaser';
import { create } from './create';
import { preload } from './preload';
import { update } from './update';

// import { store } from '../stores/mainStore';

const w =  480 * 2;
const h =  852 * 2;

// var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
var config = {
	type: Phaser.AUTO,
	width: w, height: h,
	audio: {
		disableWebAudio: false //iOS
	},
	scale: {
		parent: 'game-target',
		autoCenter: Phaser.Scale.CENTER_HORIZONTALLY,
		// autoCenter: Phaser.Scale.CENTER_BOTH,
		// mode: Phaser.Scale.RESIZE,
		mode: Phaser.Scale.FIT,
		width: w, height: h,
	},
	pixelArt: false,
	physics: {
		// default: 'arcade',
		// arcade: {
        // //    debug: true,
		// 	gravity: { x:0, y: 0 },
		// 	overlapBias: 55,
		// 	// tileBias:	200,
		// }
		default: 'matter',
		matter: {
			// debug: true
		}
	},
	callbacks: {
		postBoot: function (game) {
			// console.log(game);
			// document.addEventListener('touchstart', () => {
			// 	store.errorMessage = 'vis change ' + document.hidden;
			// 	gameSetTimeout(() => {store.errorMessage = '';}, 1000);
			// 	if (!document.hidden) {
			// 		window.focus();
			// 		gameSetTimeout(() => {
			// 			m.game.sound.context.resume();
			// 			m.game.sound.resumeAll();
			// 		}, 100);
			// 	}
			// }, false);
			// game.canvas.ontouchstart = function(){
			// 	store.errorMessage = 'focus touch';
			// 	gameSetTimeout(() => {store.errorMessage = '';}, 500);
			// 	game.canvas.focus();
			// 	m.game.sound.context.resume();
			// }
			// game.canvas.onmousedown = function(){
			// 	store.errorMessage = 'focus mouse';
			// 	gameSetTimeout(() => {store.errorMessage = '';}, 500);
			// 	game.canvas.focus();
			// 	m.game.sound.context.resume()
			// }
			// // var config = game.config;
			// // var style = game.canvas.style;
		}
	},
	scene: {
		preload: preload,
		create: create,
		update: update
	}
};


export function phaserMain(width, height){
	const m = window.manager;
	let oldAsp = config.width/config.height;
	let newAsp = width/height;

	if(oldAsp < newAsp){
		//new is wider than old
		config.width = (config.height * width) / height;
	} else {
		config.height = (config.width * height) / width;
	}
	config.scale.width = config.width;
	config.scale.height = config.height;
	config.transparent = true;

	m.calcDimensions({
		width: config.width,
		height: config.height
	});

	console.log('config', config);
	m.game = window.game = new Phaser.Game(config);
	m.game.sound.pauseOnBlur = false;
	console.log('NEW PHASER GAME');
}